export default {
  imageFilter: {
    tone: 'Tint',
    saturation: 'Saturation',
    brightness: 'Brilliance',
    ambiguity: 'Blurry',
    title: 'Filter',
  },
  colorFilter: {
    title: 'Color Filter',
  },
  colorPicker: {
    single: 'Solid',
    gradient: 'Gradient',
  },
  fontLoader: {
    title: 'Font Folder',
    loading: 'loading',
    currentFont: 'Current Font',
    freeFont: 'Free Font (commercially available)',
    systemFont: 'Device default font',
    forbidden: 'The font has been removed',
    all: 'All',
    applyFont: 'Apply to texts in the same language',
    applyFontSuccess: 'Apply Successfully',
    assetFont: 'Uploaded',
    assetFontTip: 'Please confirm the copyright of the custom uploaded font.',
  },
  fileMeta: {
    fileSize: 'File size',
    audioDuration: 'Audio Duration',
    imageSize: 'Image Size',
  },
  orientationSelector: {
    vertical: 'Portrait',
    horizontal: 'Landscape',
  },
  ratioSelector: {
    vertical: 'Vertical',
    horizontal: 'Horizontal',
  },
  storagefull: {
    tips: 'The storage is full and cannot be operated. Please clean up the asset library or contact sales for space expansion.',
  },
  batchDeal: {
    selected: '{num} Selected',
    selectAll: 'Select All',
    reverse: 'Reverse Election',
    cancel: 'Clear All',
  },
  translate: {
    selected: '{num} Selected',
    selectAll: 'Select All',
    title: 'Text Translation',
    error: 'Translations for this language are not supported at this time.',
    error1:
      'To modify the language, please complete all text input below first.',
    selectSource: 'Original Language',
    select: 'Please Choose',
    commonLanguage: 'Common',
    allLanguage: 'All Languages',
    originLanguage: 'Original',
    otherLanguage: 'Other',
    selectTarget: 'Target Language',
    translate: 'Translate (Beta)',
    error2: 'Please Enter Text',
    error3: 'Request timed out, please',
    error3Btn: 'try again.',
    track: 'Text Track',
    subtitleTrack: 'Subtitle Track',
    default: 'Default Language',
    modify: 'Language to Modify',
    saveAs: 'Save as Project and Replace',
    cancel: 'Cancel',
    replace: 'Replace',
    add: 'Add',
    done: 'Done',
    saveAsSuccess: 'Saved as project successfully',
    selectSource1: 'Choose the language for the Following Text',
    selectSource2: 'Choose the Project Language to Translate',
  },
  forbiddenFontDialog: {
    title: 'Font Missing',
    forbiddenFont: 'Font Missing',
    replaceFont: 'Replacement',
  },
  videoClip: {
    clearSign: 'Clear Markers',
    resetSign: 'Reset Markers',
    tour: {
      step1:
        'You can click on the markers in the progress bar to jump to the corresponding position.',
      step2:
        'By dragging the pointer and clicking the "+" button, you can add markers to split the video.',
      step3: "Click the '-' button to remove markers for splitting the video.",
      step4: 'The segmented video clips can be saved to the project assets.',
    },
  },
  speech: {
    title: 'Intelligently Dub',
    labelLanguage: 'Subtitle Language',
    labelType: 'Voice Type',
    checkLabel: 'Include English',
    lower: 'Lower Tone',
    low: 'Low Tone',
    normal: 'Normal Tone',
    high: 'High Tone',
    higher: 'Higher Tone',
  },
  assets: {
    transcode: {
      transcoding: 'Transcoding',
      error: 'Transcoding Failed',
    },
  },
  upload: {
    renamedTip: 'File name already exists. It has been renamed and uploaded.',
    successfully: 'File uploaded successfully - {checkName}.',
    fileStatus: {
      success: 'Upload Successfully',
      error: 'Upload Failed',
      uploading: 'Uploading',
      invalid: 'Unsupported File Format',
      invalidType: 'Uploading files of other types is not allowed.',
      warningDragonboneSize: 'DragonBones size cannot exceed {size}MB.',
      warningXlzSize: 'Sequence size cannot exceed {size}MB.',
      warningMaxSize: 'File size cannot exceed {size}MB.',
      resolveError: 'File processing failed.',
      verticesRules:
        'There are cases where vertex, normal, or texture coordinates are false.',
      meshesRules: 'The number of model meshes is not 1.',
      materialRules: 'The number of materials is not 1.',
      skinRules: 'The number of skins is not 1.',
      skeletonRules: 'The bone names are inconsistent with the template.',
    },
    sequenceFrameSizeDifferent: 'Inconsistent sequence dimensions.',
    sequenceFrameError:
      'Please upload sequence files that meet the format and size requirements.',
    fontWaring: 'Supports {type} format, max {size}.',
  },
  tour: {
    skip: 'Skip',
    next: 'Next',
    finish: 'Got it',
  },
  resourceManager: {
    commonAudio: 'Public Sound',
    commonBgm: 'Public BGM',
    commonAImage: 'Public Motion Graphic',
    commonModel: 'Model Lib',
    commonAction: 'Animation Lib',
  },
  apiError:
    'An interface error occurred. Please try again later or contact the developer.',
  productDialog: {
    title: 'Associate with Product',
    subtitle:
      'You need to associate the product store address first before proceeding to the next step.',
    read: 'Read',
    placeholder: 'Please input the store address',
    ok: 'Confirm',
    cancel: 'Cancel',
    add: 'Add',
    urlError: 'The address is incorrect, so information cannot be read.',
  },
  projectNamePlaceholder: 'Project Name',
  aiPrivacy: {
    title: 'Disclaimer for AI-generated content',
    content:
      'This feature is based on 3rd-party generative AI models, with content entirely generated by AI or modified entirely by AI based on user input. By choosing to use the Services, users are deemed to have accepted and agreed to be bound by <a href="/#/ai-agreement" target="_blank">Playturbo Platform Third-Party AI System Supplemental Agreement</a> and the agreements and rules related to Playturbo Platform and the Services.',
    cancel: 'Disagree',
    agree: 'Agree',
  },
  aiGenerationFunction: {
    long: 'Make Longer',
    short: 'Make Shorter',
    better: 'Improve Writing',
    translate: 'Retranslate',
  },
  aitool: {
    placeholderTip: 'Please select or enter a prompt',
  },
  action: {
    search: 'Find',
    replace: 'Replace',
    replaceAndTranslate: 'Replace and Translate',
    cancel: 'Cancel',
    findOutCount: 'Found {num} instances',
  },
  tone: {
    search: {
      role: 'Role',
      style: 'Style',
      model: 'Voice',
    },
    style: {
      cheerful: 'Cheerful',
      sad: 'Sad',
      assistant: 'Assistant',
      chat: 'Chat',
      customerservice: 'Customerservice',
      newscast: 'Newscast',
      angry: 'Angry',
      excited: 'Excited',
      friendly: 'Friendly',
      terrified: 'Terrified',
      shouting: 'Shouting',
      unfriendly: 'Unfriendly',
      whispering: 'Whispering',
      hopeful: 'Hopeful',
      narrationprofessional: 'Narration-Professional',
      newscastcasual: 'Newscast-Casual',
      newscastformal: 'Newscast-Formal',
      empathetic: 'Empathetic',
      calm: 'Calm',
      affectionate: 'Affectionate',
      disgruntled: 'Disgruntled',
      fearful: 'Fearful',
      gentle: 'Gentle',
      lyrical: 'Lyrical',
      serious: 'Serious',
      poetryreading: 'Poetry-Reading',
      chatcasual: 'Chat-Casual',
      whisper: 'Whisper',
      sorry: 'Sorry',
      narrationrelaxed: 'Narration-Relaxed',
      embarrassed: 'Embarrassed',
      depressed: 'Depressed',
      sportscommentary: 'Sports-Commentary',
      sportscommentaryexcited: 'Sports-Commentary-Excited',
      documentarynarration: 'Documentary-narration',
      envious: 'Envious',
      advertisementupbeat: 'Advertisement-Upbeat',
      livecommercial: 'Live Commercial',
    },
    role: {
      Narrator: 'Narrator',
      YoungAdultMale: 'Young Adult Male',
      Boy: 'Boy',
      YoungAdultFemale: 'Young Adult Female',
      OlderAdultFemale: 'Older Adult Female',
      OlderAdultMale: 'Older Adult Male',
      SeniorFemale: 'Senior Female',
      SeniorMale: 'Senior Male',
      Girl: 'Girl',
    },
  },
  gender: {
    male: 'Male',
    female: 'Female',
    neutral: 'Unlimited',
  },
}
